import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke092aRequest, Sgke092aResponseSearchresultList, Sgke094aRequest, Sgke094aRequestKinkoInfo, Szza012aRequest } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { Sgke090dConditionComponent } from '../../components/sgke090d-condition/sgke090d-condition.component';
import { Sgke090dResultComponent } from '../../components/sgke090d-result/sgke090d-result.component';
import { UsedSgke092aService } from '../../services/used-sgke092a.service';
import { UsedSgke094aService } from '../../services/used-sgke094a.service';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke090d',
  templateUrl: './sgke090d.component.html',
  styleUrl: './sgke090d.component.scss'
})
export class Sgke090dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  @ViewChild(Sgke090dConditionComponent) sgke090dConditionComponent!: Sgke090dConditionComponent;
  @ViewChild(Sgke090dResultComponent) sgke090dResultComponent!: Sgke090dResultComponent;

  /** 未精算情報取得件数 */
  kinkoinfoShtkNumber: number = 0;
  /** 検索結果リスト */
  searchresultList: Array<Sgke092aResponseSearchresultList> = new Array<Sgke092aResponseSearchresultList>();
  /** コード変換マスタマップ */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;
  /** 未精算関連承認検索APIリクエスト */
  requestSgke092a: Sgke092aRequest;
  /** 未精算関連承認APIリクエスト */
  requestSgke094a: Sgke094aRequest;

  /** 業務日付 */
  businessDate: Date;
  /** SGKE092Aリクエストデータフォーム */
  sgke092arequestData: UntypedFormGroup;
  /** ダブルクリック押下フラグ */
  dblClickFlg: boolean = false;
  /**
   * コンストラクタ
   * @param {UsedSzza012aService} initService
   * @param {UsedSgke092aService} searchService
   * @param {UsedSgke094aService} approvalService
   * @param {CodeConversionMstService} codeConversionMstService
   * @param {ChangeDetectorRef} cd
   * @param {TimeApiService} timeApiService
   * @param {UntypedFormBuilder} fb
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke090dComponent
   */
  constructor(
    public initService: UsedSzza012aService,
    public searchService: UsedSgke092aService,
    public approvalService: UsedSgke094aService,
    private codeConversionMstService: CodeConversionMstService,
    private cd: ChangeDetectorRef,
    private timeApiService: TimeApiService,
    private fb: UntypedFormBuilder,
    public responseMsgUtils: ResponseMsgUtils,
  ) {
  }

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * 初期処理
   * @memberof Sgke090dComponent
   */
  ngOnInit(): void {
    // コード変換マスタ取得
    this.codeConversionMstService.getCodeConversionMst(['S300471', 'S100033'])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        // ローカルに保存
        this.codeConversionMstMap = data;
      });


    // リクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null
    };

    // SZZA012A呼び出し
    this.initService.doSzza012a(this.requestSzza012a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.todayDay) {
          this.businessDate = this.timeApiService.convertStringToDate(response.todayDay);
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      }
    );

    // 未精算関連承認検索APIのFormを初期化
    this.sgke092arequestData = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });

    this.cd.detectChanges();
  }

  /**
   * 購読解除
   * @memberof Sgke090dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 検索ボタン押下時処理
   * @param {boolean} [reSearch=false]
   * @return {*}  {void}
   * @memberof Sgke090dComponent
   */
  onClickSearch(reSearch: boolean = false): void {
    // 再検索時はメッセージエリアをクリアしない
    if (!reSearch) {
      this.clearErrorMsg();
    }

    // searchResult初期化
    this.searchresultList.length = 0;

    // 日付範囲の相関チェック
    const startDate = this.sgke092arequestData.get('samplingCndt.apprvreqYearmonthdateStart').getRawValue();
    const endDate = this.sgke092arequestData.get('samplingCndt.apprvreqYearmonthdateEnd').getRawValue();

    if (startDate > endDate) {
      this.errorMessageModelArray.push(this.responseMsgUtils.showErrorMsg('承認依頼年月日（開始）は承認依頼年月日（終了）と同日または過去日で入力してください'));
      return;
    }

    // 再検索時はリクエストを作らない（初回検索時のリクエストを再利用する）
    if (!reSearch) {
      // リクエスト情報をもつオブジェクトを定義
      this.requestSgke092a = this.sgke092arequestData.getRawValue() as Sgke092aRequest;
    }

    // SGKE092A呼び出し
    this.searchService.doSgke092a(this.requestSgke092a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.shtkInfo?.searchresultList) {
          this.searchresultList = response.shtkInfo.searchresultList;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

      },
      error => {
      }
    );

  }

  /**
   * 承認ボタン押下時処理
   * @param {Sgke092aResponseSearchresultList[]} selected
   * @memberof Sgke090dComponent
   */
  onClickApproval(selected: Sgke092aResponseSearchresultList[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // 未精算金情報オブジェクト生成関数
    let kinkoInfoRequestFunc = function (row: Sgke092aResponseSearchresultList): Sgke094aRequestKinkoInfo {
      return {
        kinkoMno: row.kinkoMno,
        kinkoRrkno: row.kinkoRrkno,
        kinkoUpdateSrno: row.kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: row.kinkoexUpdatesequencenumber,
        recptFixNo: row.payCtrNo,
        kinkoStatuscode: row.kinkoStatuscode,
        rcvmnyProcessingresultRcvinfno: row.rcvmnyProcessingresultRcvinfno,
        repayMno: row.repayMno,
        repayAchievUpdateSrno: row.repayAchievUpdateSrno,
        repayachievexUpdatesequencenumber: row.repayachievexUpdatesequencenumber,
        kinkoBusinessClscode: row.kinkoBusinessClscode,
        claimVisitornumberTransferdestination: row.transferdestinationPaymentcontractNo
      };
    }

    // 承認リクエスト情報をもつオブジェクトを定義
    this.requestSgke094a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      regCndt: {
        kinkoInfo: selected.map(kinkoInfoRequestFunc)
      }
    }

    // SGKE094A呼び出し
    this.approvalService.doSgke094a(this.requestSgke094a).pipe(takeUntil(this.onDestroy$)).subscribe(

      response => {
        if (response) {
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
          // 再検索
          this.onClickSearch(true);
        }
      },
      error => {
      }
    );
  }

  /**
   * クリアボタン押下時処理
   * @memberof Sgke090dComponent
   */
  onClickClear(): void {
    // エラーメッセージをクリア
    this.clearErrorMsg();
    // searchResult初期化
    this.searchresultList.length = 0;
  }

  /**
    * エラーメッセージ表示領域をクリア
    * @private
    * @memberof Sgke090dComponent
    */
  public clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

    /**
   * ダブルクリック押下フラグをセット
   * @memberof Sgke090dComponent
   */
  dblClickFlgSet() {
    this.dblClickFlg = true;
  }
}

